/// <amd-module name="Build/Designer/PipelineEditorBreadcrumbService" />
import { BuildDefinition } from "Build/Client/Contracts/Build";
import { IBuildLinkingService } from "Build/Client/Linking";
import * as Resources from "Build/Designer/Resources";

import { IReadonlyObservableArray, ObservableArray } from "VSS/Core/Observable";
import { IVssService, Services, VssService } from "VSS/Platform/Context";
import { onClickFPS } from "VSS/Platform/FPS";
import { IVssBreadcrumbItem } from "VSSUI/VssBreadcrumb";

import { IBreadcrumbItemService } from "VSS/Features/PlatformUI/ContributedBreadcrumb";
import { IBreadcrumbItem } from "VSSUI/Breadcrumb.Types";

export interface IPipelineEditorBreadcrumbService extends IReadonlyObservableArray<IVssBreadcrumbItem>, IVssService {
    setPipeline(definition?: BuildDefinition): void;
    clearPipeline(): void;
}

class PipelineEditorBreadcrumbService extends VssService implements IBreadcrumbItemService {
    
    private items = new ObservableArray<IBreadcrumbItem>();
    
    public getBreadcrumbItems(breadcrumbId: string): IReadonlyObservableArray<IBreadcrumbItem> {
        return this.items;
    }

    public setPipeline(definition?: BuildDefinition) {
        const telemetrySource = "pipeline-editor-breadcrumb";
        this.items.removeAll();

        const buildsHubUrl = this.buildLinkingService.getDefinitionUrl();
        this.items.push(
            {
                key: "pipeline-editor-builds-breadcrumb",
                text: Resources.BuildsHubName,
                href: buildsHubUrl,
                onClick: (ev) => { onClickFPS(this.pageContext, buildsHubUrl, true, ev, { telemetrySource }) }
            });

        if (definition) {
            const definitionUrl = this.buildLinkingService.getDefinitionUrl(definition.id);
            this.items.push(
                {
                    key: "pipeline-editor-definition-breadcrumb",
                    text: definition.name,
                    href: definitionUrl,
                    onClick: (ev) => { onClickFPS(this.pageContext, definitionUrl, true, ev, { telemetrySource }) }
                },
                {
                    key: "pipeline-editor-pipeline-yaml-breadcrumb",
                    text: Resources.Yaml
                });
        }
    }

    public clearPipeline() {
        this.items.removeAll();
    }

    private get buildLinkingService(): IBuildLinkingService {
        return this.pageContext.getService<IBuildLinkingService>("IBuildLinkingService")
    }
}

Services.add("pipeline-editor-breadcrumb-service", { serviceFactory: PipelineEditorBreadcrumbService });
